// extracted by mini-css-extract-plugin
export default {"packageHeader":"classroom_packageHeader__D3hH2","table":"classroom_table__5GO9q","thead":"classroom_thead__zK8g7","th":"classroom_th__913Km","td":"classroom_td__6swMc"};